import { AwsUtil } from './../authentication/aws.service';
import { AppConfig } from './../app.config';
import { DashboardMetricBarComponent } from '../dashboard/metric/dashboard-metric-bar.component';
import { SnapshotService } from './../snapshot/snapshot.service';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { Subscription } from 'rxjs';
import { CommunicationService } from './../common/communication.service';
import {
    RISK_GRAPHICAL_CONFIGS,
    RISK_DASHBOARD_REQUESTS,
    RISK_DASHBOARD_RESPONSE_PROCESSORS,
    RISK_GRAPHICAL_OPTIONAL_FILTERS,
    RiskGraphicalAdditionalFilter,
    RISK_DASHBOARD_REQUEST_PROCESSORS,
    RISK_GRAPHICAL_YFIELDS,
} from './risk-graphical/risk-graphical-config';
import { DashboardMetricSet } from './../dashboard/dashboard-metric';
import { DashboardGraphicalConfig } from '../dashboard/dashboard-graphical';
import { DashboardViewSelection } from '../dashboard/dashboard-view-selection';
import { MenuItem } from 'primeng/api';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import {
    RiskDashboardRequest,
    RiskDashboardFieldType,
    RiskMetricDataUsageType,
    WebApiEndpoints
} from '@liquitics/transaction';
import { UserProfileRiskManager } from '@liquitics/transaction';
import { DashboardMetricCategory } from '@liquitics/transaction';
import { convertFromConstantToHuman } from '@liquitics/transaction';

import { createPieChart, createSerialChart, createXYChart } from '../dashboard/dashboard-graphical-chart-generator';


interface FilterItem {
    name: string,
    code: string
}
@Component({
    selector: 'app-risk-manager',
    templateUrl: './risk-manager.component.html',
    styleUrls: ['./risk-manager.component.scss'],
    encapsulation: ViewEncapsulation.None
})


export class RiskManagerComponent implements OnInit, OnDestroy, AfterViewInit {
    showTopLevelMetrics = true;
    isChartEnabled = false;
    chartReady = true;
    chart: any;
    breadcrumbs;
    additionalFilterLabels = ['Optional Filter by ...'];
    additionalFilterValues: any[][];
    additionalFilterRequireds: boolean[];
    selectedAdditionalFilterValues: FilterItem[];
    tempSelectedValue;

    selectableCategories: DashboardMetricCategory[];
    selectedCategory: DashboardMetricCategory;
    selectedSubType: string;
    selectedSubcategory: string;
    selectableSubcategories: string[];
    selectableGraphicalConfigs: DashboardGraphicalConfig[];
    selectedDashboardGraphicalConfig: DashboardGraphicalConfig
    categoryItems: MenuItem[];
    selectableRiskDataUsageTypes: string[];

    selectedCurrency: string;
    selectedUsageType: RiskMetricDataUsageType;

    viewSelection: DashboardViewSelection<unknown>;

    referenceDate = '2018-01-12'; // this.appConfig.getTodayString(); '2018-05-28'; '2018-02-21';//TODO change with value from appconfig

    subscription: Subscription;

    @ViewChild(DashboardMetricBarComponent, { static: true })
    dashboardMetricBarComponent: DashboardMetricBarComponent;

    constructor(private amChartsService: AmChartsService,
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig,
        private awsUtil: AwsUtil,
        private communicationService: CommunicationService) { }

    ngOnInit() {
        this.breadcrumbs = [];
        this.subscription = this.dashboardEventService.viewSelectionSubject.subscribe({
            next: (viewSelection: DashboardViewSelection<unknown>) => {
                this.viewSelection = viewSelection;
                this.selectedCurrency = viewSelection.currency;
                this.clearChart();
            }
        });
        /*
        this.subscription = this.dashboardEventService.currencySelectionSubject.subscribe({next: (currency: string) => {
            if (this.selectedCurrency !== currency) {
                this.selectedCurrency = currency;
                this.clearChart();
            }
        });
        */
        this.subscription.add(this.dashboardEventService.viewModeSelectionSubject.subscribe({
            next: (mode: string) => {
                this.isChartEnabled = (mode === 'chart');
            }
        }));
        this.subscription.add(this.dashboardEventService.dashboardMetricCategorySubject.subscribe({
            next: (metricSet: DashboardMetricSet) => {
                this.showCategory(metricSet);
            }
        }));
        this.subscription.add(this.dashboardEventService.dashboardGraphicalConfigSubject.subscribe({
            next: (config: DashboardGraphicalConfig) => {
                this.showConfig(config);
            }
        }));
        if (this.appConfig.activeUserProfile instanceof UserProfileRiskManager) {
            const profile = this.appConfig.activeUserProfile as UserProfileRiskManager;
            this.selectableCategories = profile.getRiskMetricCategories();
        }
        // this.selectableRiskDataUsageTypes = Object.keys(RISK_METRIC_DATA_USAGE_TYPES).map(convertFromConstantToHuman);
        this.initializeSideMenu();
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    showCategory(metricSet: DashboardMetricSet) {
        let showFirstGraphicalConfig = false;
        let changeSubcategory = false;
        let category: DashboardMetricCategory;
        if (metricSet) {
            category = metricSet.category;
            if (metricSet.subType) {
                this.selectedSubType = metricSet.subType;
            } else {
                this.selectedSubType = undefined;
            }
        }
        if (this.selectedCategory !== category) {
            showFirstGraphicalConfig = true;
            changeSubcategory = true;
        }
        this.selectedCategory = category;
        const DashboardGraphicalConfigs = RISK_GRAPHICAL_CONFIGS
            .filter((config: DashboardGraphicalConfig) => {
                return category && config.category.identifier === category.identifier;
            });

        const selectableCategoriesData: string[] = [];
        DashboardGraphicalConfigs
            .filter((DashboardGraphicalConfigRow) => {
                if (!this.selectedSubType || this.selectedSubType !== 'All') {
                    return DashboardGraphicalConfigRow['subCategory'] !== 'Compare Stresses';
                } else {
                    return DashboardGraphicalConfigRow['subCategory'] === 'Compare Stresses';
                }
            })
            .forEach((DashboardGraphicalConfigRow, index: number) => {
                selectableCategoriesData[index] = DashboardGraphicalConfigRow['subCategory'];
            });
        this.selectableSubcategories = selectableCategoriesData.sort().reduce(
            (selectableSubcategories, row) => {
                const length = selectableSubcategories.length;
                if (length === 0 || selectableSubcategories[length - 1] !== row) {
                    selectableSubcategories.push(row);
                }
                return selectableSubcategories;
            }, []);
        if (changeSubcategory) {
            if (!this.selectedSubType || this.selectedSubType !== 'All') {
                this.selectedSubcategory = 'Single Day';
            } else {
                this.selectedSubcategory = 'Compare Stresses';
                showFirstGraphicalConfig = true;
            }
        }
        this.selectableGraphicalConfigs = RISK_GRAPHICAL_CONFIGS
            .filter((config: DashboardGraphicalConfig) => {
                return category && ((config.category.identifier === category.identifier)
                    && (config.subCategory === this.selectedSubcategory));
            });
        if (showFirstGraphicalConfig) {
            this.dashboardEventService.dashboardGraphicalConfigSubject.next(this.selectableGraphicalConfigs[0]);
        }
    }

    showSubcategory(subCategory: string) {
        let showFirstGraphicalConfig = false;
        if (this.selectedSubcategory !== subCategory) {
            showFirstGraphicalConfig = true;
        }
        this.selectedSubcategory = subCategory;

        this.selectableGraphicalConfigs = RISK_GRAPHICAL_CONFIGS
            .filter((config: DashboardGraphicalConfig) => {
                return subCategory && ((config.subCategory === subCategory) &&
                    (config.category.identifier === this.selectedCategory.identifier));
            });
        if (showFirstGraphicalConfig) {
            this.dashboardEventService.dashboardGraphicalConfigSubject.next(this.selectableGraphicalConfigs[0]);
        }
    }

    changeUsageType(usageType: RiskMetricDataUsageType) {
        this.selectedUsageType = usageType;
        this.filterValueChanged(null, 0);
    }

    filterValueChanged(event, filterIndex: number) {
        if (this.selectedDashboardGraphicalConfig) {
            this.selectedAdditionalFilterValues[filterIndex] = event.value;
            this.showConfig(this.selectedDashboardGraphicalConfig);
        }
    }

    clearFilterSelection(index: number) {
        // const randomIndex = Math.random() > 0.5 ? 1 : 0;
        // this.tempSelectedValue = this.additionalFilterValues[index][randomIndex].code;
        // this.tempSelectedValue = '2018-01-01';
        // const randomIndex = Math.random() > 0.5 ? 1 : 0;
        // this.selectedAdditionalFilterValues[index] = this.additionalFilterValues[index][randomIndex].code;
        // const newArray = this.selectedAdditionalFilterValues.map((v) => v);
        // this.selectedAdditionalFilterValues = newArray;
        this.selectedAdditionalFilterValues[index] = undefined;
        if (this.selectedDashboardGraphicalConfig) {
            this.showConfig(this.selectedDashboardGraphicalConfig);
        }
    }

    clearAdditionalFilterSettings() {
        if (this.additionalFilterValues) {
            this.additionalFilterValues.length = 0;
        }
        if (this.additionalFilterRequireds) {
            this.additionalFilterRequireds.length = 0;
        }
        if (this.selectedAdditionalFilterValues) {
            this.selectedAdditionalFilterValues.length = 0;
        }

    }

    onDashboard() {
        this.dashboardEventService.dashboardMetricCategorySubject.next(null);
    }

    showConfig(config: DashboardGraphicalConfig): void {
        this.chartReady = false;
        this.chartFromConfig(config)
            .then((chart: AmChart | undefined) => {
                if (chart) {
                    this.chart = chart;
                    this.chartReady = true;
                } else {
                    this.clearChart();
                    this.chartReady = true;
                }
            })
            .catch((err) => {
                this.communicationService.openSnackBar(err, null);
                this.dashboardEventService.emergencyMessageSubject.next({
                    severity: 'error',
                    summary: 'Authentication Error',
                    detail: 'Invalid session. Please re-login:' + err
                });
                console.log(err);
                this.chartReady = true;
            })
    }

    chartFromConfig(config: DashboardGraphicalConfig): Promise<AmChart | undefined> {
        if (!config || (this.selectedDashboardGraphicalConfig && this.selectedDashboardGraphicalConfig.code !== config.code)) {
            this.clearAdditionalFilterSettings();
        }
        this.selectedDashboardGraphicalConfig = config;
        let request: RiskDashboardRequest;
        if (config) {
            request = RISK_DASHBOARD_REQUESTS[config.code];
            this.breadcrumbs = [];
            this.breadcrumbs.push({ label: this.selectedCurrency });
            this.breadcrumbs.push({ label: this.selectedUsageType });
            this.breadcrumbs.push({ label: config.category.label });
            this.breadcrumbs.push({ label: config.label });
            // this.breadcrumbs.push({ label: this.selectedView }); // TODO ???
            if (request) {
                const clonedRequest: RiskDashboardRequest = Object.assign(new RiskDashboardRequest(), request);
                clonedRequest.usageType = this.selectedUsageType;
                clonedRequest.currency = this.selectedCurrency;
                clonedRequest.subType = this.selectedSubType;
                return this.chartRequest(clonedRequest, config);
            } else {
                this.communicationService.openSnackBar('Not yet implemented', '', 3000);
                return Promise.resolve(undefined);
            }
        } else {
            return Promise.resolve(undefined);
        }
    }

    getMenuIcon(config: DashboardGraphicalConfig): string {
        switch (config.chartType) {
            case 'DefaultPie':
                return 'fa-pie-chart';
            case 'DefaultLine':
            case 'TimeLine':
                return 'fa-line-chart';
            case 'DefaultColumn':
                return 'fa-bar-chart';
            default:
                return 'fa-circle-o';
        }

    }

    clearChart() {
        if (this.chart) {
            this.amChartsService.destroyChart(this.chart);
        }
    }

    processAdditionalFilters(request: RiskDashboardRequest, config: DashboardGraphicalConfig): Promise<RiskDashboardRequest> {
        const additionalFilters: RiskGraphicalAdditionalFilter[] = RISK_GRAPHICAL_OPTIONAL_FILTERS[config.code];

        const baseRequest = Object.assign(new RiskDashboardRequest(), request);
        if (additionalFilters) {
            // If there are additional filters, process them
            this.additionalFilterLabels = this.additionalFilterLabels || [];
            this.additionalFilterValues = this.additionalFilterValues || [];
            this.additionalFilterRequireds = this.additionalFilterRequireds || [];
            this.selectedAdditionalFilterValues = this.selectedAdditionalFilterValues || [];
            return Promise.all(additionalFilters.map((additionalFilter: RiskGraphicalAdditionalFilter, filterIndex: number) => {
                let filterPlaceholder: string;
                if (additionalFilter.required) {
                    filterPlaceholder = 'Filter by ' + additionalFilter.label;
                } else {
                    filterPlaceholder = 'Optional Filter by ' + additionalFilter.label;
                }

                this.additionalFilterLabels[filterIndex] = filterPlaceholder;
                this.additionalFilterRequireds[filterIndex] = additionalFilter.required;

                // Run a query to get the valid values for each additional filter
                const filterValuesRequest = Object.assign(new RiskDashboardRequest(), baseRequest);
                filterValuesRequest.fields = [additionalFilter.filterField] as RiskDashboardFieldType[];
                // const filterValuesInvokeParam = {
                //     FunctionName: 'LiquiticsBank-QueryRiskData',
                //     Payload: JSON.stringify(filterValuesRequest)
                // } as AWS.Lambda.Types.InvocationRequest;
                if (!this.viewSelection || this.viewSelection.type === 'Risk') {
                    return this.awsUtil.webAPICall(WebApiEndpoints.QueryRiskData, filterValuesRequest)
                        .then((payload: any) => {
                            const filterValueRows = payload;
                            if (filterValueRows) {
                                this.additionalFilterValues[filterIndex] = filterValueRows
                                    .map((filterValueRow: any) => {
                                        return {
                                            name: convertFromConstantToHuman(filterValueRow[additionalFilter.filterField]),
                                            code: filterValueRow[additionalFilter.filterField]
                                        } as FilterItem;
                                    })
                                    .sort((fv1: FilterItem, fv2: FilterItem) => {
                                        if (additionalFilter.filterField === 'date') {
                                            return fv1.code > fv2.code ? -1 : 1;
                                        }
                                        return fv1.code < fv2.code ? -1 : 1;
                                    })
                                    ;
                                if (!this.selectedAdditionalFilterValues[filterIndex]) {
                                    if (additionalFilter.required) {
                                        // Populate with first entry if none is selected
                                        this.selectedAdditionalFilterValues[filterIndex] = this.additionalFilterValues[filterIndex][0];
                                    }
                                }
                            } else {
                                this.additionalFilterValues[filterIndex] = [];
                            }
                        });
                } else {
                    // change to stress function call
                    return this.awsUtil.webAPICall(WebApiEndpoints.QueryStressedRiskData, filterValuesRequest)
                        .then((payload: any) => {
                            const filterValueRows = payload;
                            if (filterValueRows) {
                                this.additionalFilterValues[filterIndex] = filterValueRows
                                    .map((filterValueRow: any) => {
                                        return {
                                            name: convertFromConstantToHuman(filterValueRow[additionalFilter.filterField]),
                                            code: filterValueRow[additionalFilter.filterField]
                                        } as FilterItem;
                                    })
                                    .sort((fv1: FilterItem, fv2: FilterItem) => {
                                        if (additionalFilter.filterField === 'date') {
                                            return fv1.code > fv2.code ? -1 : 1;
                                        }
                                        return fv1.code < fv2.code ? -1 : 1;
                                    })
                                    ;
                                if (!this.selectedAdditionalFilterValues[filterIndex]) {
                                    if (additionalFilter.required) {
                                        // Populate with first entry if none is selected
                                        this.selectedAdditionalFilterValues[filterIndex] = this.additionalFilterValues[filterIndex][0];
                                    }
                                }
                            } else {
                                this.additionalFilterValues[filterIndex] = [];
                            }
                        });
                }
            }))
                .then(() => {
                    const requestProcessor = RISK_DASHBOARD_REQUEST_PROCESSORS[config.code];
                    const filterValues = this.selectedAdditionalFilterValues
                        .filter((value: FilterItem) => {
                            return value;
                        })
                        .map((value: FilterItem) => {
                            return value.code;
                        })
                        ;
                    if (requestProcessor) {
                        const referenceDate = this.referenceDate;
                        request = requestProcessor({ referenceDate, filterValues, request, config, })
                    } else {
                        // Default Behavior
                        if (additionalFilters) {
                            additionalFilters.forEach((filter: RiskGraphicalAdditionalFilter, filterIndex: number) => {
                                if (filter.filterField === 'date') {
                                    request.date = filterValues[filterIndex];
                                } else {
                                    request[filter.filterField] = filterValues[filterIndex];
                                }
                            });
                        }
                    }
                    // After all queries are run and all values are set (including required entries)
                    // return the modified request so it can be used to run the main query to generate the chart.
                    return request;
                });
        }
        return Promise.resolve(request);
    }

    private createChart(request: RiskDashboardRequest, config: DashboardGraphicalConfig, rows: any[]): AmChart {
        if (!rows) {
            rows = [];
        }
        let yFields = [];
        let xField = '';
        const responseProcessor = RISK_DASHBOARD_RESPONSE_PROCESSORS[config.code];
        if (responseProcessor) {
            const referenceDate = this.referenceDate;
            const riskGraphicalOutput = responseProcessor({ rows, request, config, referenceDate });
            if (riskGraphicalOutput.graphicalOutputData) {
                rows = riskGraphicalOutput.graphicalOutputData;
                yFields = riskGraphicalOutput.yfields;
                xField = riskGraphicalOutput.xfield;
            }
        }
        if (config.chartType === 'DefaultPie') {
            return createPieChart(this.amChartsService, 'riskchartdiv',
                rows, xField, yFields[0]);
        } else if (config.chartType === 'DefaultLine') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'line', false, false,
                rows, xField, yFields);
        } else if (config.chartType === 'CompareLine') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'line', false, false,
                rows, xField, yFields, 'delta');
        } else if (config.chartType === 'TrendLine') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'line', false, false,
                rows, xField, yFields);
        } else if (config.chartType === 'TimeLine') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'line', true, false,
                rows, xField, yFields);
        } else if (config.chartType === 'CompareTimeLine') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'line', true, false,
                rows, xField, yFields, 'delta');
        } else if (config.chartType === 'DefaultColumn') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'column', false, false,
                rows, xField, yFields);
        } else if (config.chartType === 'DefaultStackedColumn') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'column', false, true,
                rows, xField, yFields);
        } else if (config.chartType === 'TimeStackedColumn') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'column', true, true,
                rows, xField, yFields);
        } else if (config.chartType === 'TimeColumn') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'column', true, false,
                rows, xField, yFields);
        } else if (config.chartType === 'CompareTimeColumn') {
            return createSerialChart(this.amChartsService, 'riskchartdiv', 'column', true, false,
                rows, xField, yFields);
        } else {
            return createXYChart(this.amChartsService, 'riskchartdiv',
                rows, xField, yFields[0]);
        }

    }

    chartRequest(baseRequest: RiskDashboardRequest, config: DashboardGraphicalConfig): Promise<AmChart> {
        return this.processAdditionalFilters(baseRequest, config)
            .then((request: RiskDashboardRequest) => {
                // const invokeParam = {
                //     FunctionName: 'LiquiticsBank-QueryRiskData',
                //     Payload: JSON.stringify(request)
                // } as AWS.Lambda.Types.InvocationRequest;
                if (!this.viewSelection || this.viewSelection.type === 'Risk') {
                    return this.awsUtil.webAPICall(WebApiEndpoints.QueryRiskData, request)
                        .then((payload: any) => {
                            const rows = payload;
                            return this.createChart(request, config, rows);
                        });
                } else {
                    return this.awsUtil.webAPICall(WebApiEndpoints.QueryStressedRiskData, request)
                        .then((payload: any) => {
                            const rows = payload;
                            return this.createChart(request, config, rows);
                        });
                }
            });
    }


    initializeSideMenu() {
        const configsByCategory = RISK_GRAPHICAL_CONFIGS.reduce((grouped, config) => {
            const key = config.category.label;
            grouped[key] = grouped[key] || [];
            grouped[key].push(config);
            return grouped;
        }, {});
        this.categoryItems = [];
        this.categoryItems.push({
            label: 'Dashboard',
            command: (event) => {
                this.dashboardEventService.dashboardMetricCategorySubject.next(null);
                // this.dashboardEventService.toggleSideBarSliderSubject.next(false);
            },
        });
        this.categoryItems.push(...Object.keys(configsByCategory)
            .map((categoryLabel: string) => {
                let category: DashboardMetricCategory;
                const items = [];
                const configsBySubCategory = configsByCategory[categoryLabel]
                    .filter((config: DashboardGraphicalConfig) => {
                        return (config.subCategory);
                    })
                    .reduce((grouped, config) => {
                        const key = config.subCategory;
                        grouped[key] = grouped[key] || [];
                        grouped[key].push(config);
                        return grouped;
                    }, {});
                Object.keys(configsBySubCategory)
                    .forEach((subCategory: string) => {
                        const subCategoryItems = [];
                        configsBySubCategory[subCategory]
                            .forEach((config: DashboardGraphicalConfig) => {
                                category = config.category;
                                subCategoryItems.push({
                                    label: config.label.replace(subCategory, ''),
                                    // icon: this.getMenuIcon(config),
                                    config: config,
                                    command: (event) => { this.dashboardEventService.dashboardGraphicalConfigSubject.next(event.item.config) }
                                });
                            });
                        items.push({
                            label: subCategory,
                            items: subCategoryItems
                        })
                    });
                configsByCategory[categoryLabel]
                    .forEach((config: DashboardGraphicalConfig) => {
                        category = config.category;
                        if (!config.subCategory) {
                            items.push({
                                label: config.label,
                                // icon: this.getMenuIcon(config),
                                config: config,
                                command: (event) => { this.dashboardEventService.dashboardGraphicalConfigSubject.next(event.item.config) }
                            });
                        }
                    })
                return {
                    label: categoryLabel,
                    items: items,
                    category: category,
                    command: (event) => { this.dashboardEventService.dashboardMetricCategorySubject.next(event.item.category) }
                }
            })
        );
    }

    pdfExport() {
        const layout = {
            content: [
                {
                    text: 'Header Text Value Goes here',
                },
                {
                    columnGap: 40,
                    columns: [{
                        stack: []
                    }],
                    style: 'safetyDistance'
                },
            ],
            images: {

            }
        }
        let lastExport: any;
        this.amChartsService.charts.forEach((chart) => {
            this.amChartsService.destroyChart(chart);
        });

        Promise.all(RISK_GRAPHICAL_CONFIGS
            .map((config: DashboardGraphicalConfig) => {
                return this.chartFromConfig(config)
                    .then((chart: AmChart) => {
                        if (chart) {
                            chart.startDuration = 0;
                            const index = this.amChartsService.charts.length - 1
                            const serviceChart = this.amChartsService.charts[index];
                            serviceChart.startDuration = 0;
                            const amExport = serviceChart.export;
                            if (amExport) {
                                lastExport = amExport;
                                amExport.capture({},
                                    function () {
                                        this.toPNG({ multiplier: 2 }, function (data) {
                                            const imageId = 'image_' + index;
                                            layout.images[imageId] = data;
                                            const content = {
                                                image: imageId,
                                                fit: [250, 200],
                                            };
                                            layout.content[1]['columns'][0].stack.push(content);
                                        })
                                    });
                            }
                        }
                    });

            })
        )
            .then(() => {
                lastExport.toPDF(layout,
                    function (data) {
                        this.download(data, this.defaults.formats.PDF.mimeType, 'riskmanagercharts.pdf');
                    })
            })
    }
    trackByIndex(index: number, value: number) {
        return index;
    }
}
